import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { Card } from 'reactstrap';
import TicketsForm from 'components/forms/TicketsForm';
import FormButtons from 'components/FormButtons';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as submissionFormActions from 'actions/submissionFormActions';
import { change, arrayInsert, arrayRemove } from 'redux-form';
import findIndex from 'lodash/findIndex';
import get from 'lodash/get';
import find from 'lodash/find';
import addHttpPrefix from 'lib/utils/addHttpPrefix';

class TicketsPage extends Component {
  static propTypes = {
    currencies: PropTypes.array.isRequired,
    geotixEnabled: PropTypes.bool.isRequired,
    geotixVanityUrl: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    submitForm: PropTypes.func.isRequired,
    goToPreviousStep: PropTypes.func.isRequired,
    formErrors: ImmutablePropTypes.map.isRequired,
    saveDraft: PropTypes.func.isRequired,
    links: PropTypes.array.isRequired,
    urlTypes: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
    ssoGeotixUrl: PropTypes.string,
  };

  componentDidMount() {
    this.presetTicketsUrl();
    this.presetDefaultCurrency();
  }

  componentDidUpdate() {
    this.updateTicketsUrl();
    this.presetPrices();
  }

  presetPrices() {
    const { currency, pricing_type, ticketingUrlType, prices } = this.props;

    if (!prices.length && (pricing_type === 'tickets_in_advance' || pricing_type === 'registration_required')) {
      this.props.dispatch(arrayInsert('eventSubmission', 'prices', 0, {}));
    }

    prices.map(
      (price, i, arr) => {
        if (i != 0) {
          if (!price.currency || price.currency.value === null) {
            price.currency = arr[i-1].currency;
          }
        }
        if (price.price === null || pricing_type === 'registration_required' && price.price !== '0.00') {
          this.props.dispatch(change('eventSubmission', `prices[${i}].name`, 'Free'));
          this.props.dispatch(change('eventSubmission', `prices[${i}].price`, '0.00'));
        }

        if (price.price === null || pricing_type === 'tickets_in_advance' && price.price === '0.00') {
          this.props.dispatch(change('eventSubmission', `prices[${i}].name`, 'General Admission'));
          this.props.dispatch(change('eventSubmission', `prices[${i}].price`, ''));
        }

        if (ticketingUrlType === 'geotix' && price.currency
            && price.currency.value !== currency.value) {
          this.props.dispatch(change('eventSubmission', 'ticketing_url_type', 'own_url'));
        }
      }
    );
  }

  presetDefaultCurrency() {
    const defaultCurrency = this.props.ticketingUrlType === 'geotix' ? 'USD' :
      get(this.props.venue, 'country.default_currency', 'USD');
    const newCurrency = this.props.currencies.find((e) => e.value === defaultCurrency);

    if (!this.props.currency || this.props.currency.value !== defaultCurrency) {
      this.props.dispatch(change('eventSubmission', 'currency', newCurrency));
    }

    if (this.props.prices.length) {
      if (!this.props.prices[0].currency || this.props.prices[0].currency.value === null) {
        this.props.prices[0].currency = newCurrency;
      }
      if (!this.props.prices[0].name) {
        this.props.dispatch(change('eventSubmission', 'prices[0].name', 'General Admission'));
      }
    }
  }

  submitForm = () => this.form.submit();

  formSubmitted = (data) => {
    if (data.pricing_type === 'tickets_in_advance' || data.pricing_type === 'registration_required') {
      if (this.props.ticketingUrlType === 'geotix' && !this.props.premiumEdit) {
        this.setTicketsUrl(this.props.geotixVanityUrl);
      } else {
        this.setTicketsUrl(data.pricing_url);
      }
    } else if (data.pricing_type === 'free' && data.ticketing_url_type === 'geotix') {
      this.props.dispatch(change('eventSubmission', 'ticketing_url_type', 'own_url'));
    }
    if (data.pricing_type === 'free') {
      this.setTicketsUrl(null);
    }
    this.props.submitForm('tickets', this.props.history, data);
  };

  goToPreviousStep = () => this.props.goToPreviousStep('tickets', this.props.history);

  setTicketsUrl = (url) => {
    const index = findIndex(this.props.links, (link) => get(link, 'type.name', '') === 'Tickets');

    if (index > -1) {
      if (url) {
        this.props.dispatch(change('eventSubmission', `links[${index}].url`, addHttpPrefix(url)));
      } else {
        this.props.dispatch(arrayRemove('eventSubmission', 'links', index));
      }
    } else {
      if(!url) return;
      const type = find(this.props.urlTypes, e => e.name === 'Tickets');
      this.props.dispatch(arrayInsert('eventSubmission', 'links', 0, {
        url: addHttpPrefix(url),
        is_primary: this.props.links.length === 0,
        type: { id: type.id, name: type.name }
      }));
    }
  };

  updateTicketsUrl = () => {
    const { dispatch, pricing_type, pricing_url, ticketingUrlType, geotixVanityUrl, ticketsRequired } = this.props;

    if (!ticketsRequired && pricing_type !== 'free') {
      dispatch(change('eventSubmission', 'tickets_required', 'yes'));
    }

    if (ticketsRequired === 'yes' && pricing_type === 'free' && ticketingUrlType === 'no_url'){
      dispatch(change('eventSubmission', 'ticketing_url_type', null));
    }

    if (ticketsRequired === 'no' && (pricing_type !== 'free' || ticketingUrlType !== 'no_url' || pricing_url !== null ) ){
      dispatch(change('eventSubmission', 'pricing_type', 'free'));
      dispatch(change('eventSubmission', 'ticketing_url_type', 'no_url'));
      dispatch(change('eventSubmission', 'pricing_url', null));
    }

    if (ticketingUrlType === 'own_url' && pricing_url === geotixVanityUrl) {
      dispatch(change('eventSubmission', 'pricing_url', null));
    }
  };

  presetTicketsUrl = () => {
    const index = findIndex(this.props.links, (link) => get(link, 'type.name', '') === 'Tickets');
    if (index > -1) {
      this.props.dispatch(change('eventSubmission', 'pricing_url', this.props.links[index].url));
    }

    this.updateTicketsUrl();
  };

  saveDraft = () => this.props.saveDraft('tickets');

  render() {
    return (
      <div>
        <FormButtons
          onNext={this.submitForm}
          onPrevious={this.goToPreviousStep}
          onSaveDraft={this.saveDraft}
        />
        <div className="row justify-content-center">
          <div className="col-md-10">
            <Card>
              <TicketsForm
                ref={(ref) => this.form = ref}
                onSubmit={this.formSubmitted}
                currencies={this.props.currencies}
                formErrors={this.props.formErrors}
                ticketing_type={this.props.pricing_type}
                ticketing_url_type={this.props.ticketingUrlType}
                geotixEnabled={this.props.geotixEnabled}
                premiumEdit={this.props.premiumEdit}
                ssoGeotixUrl={this.props.ssoGeotixUrl}
              />
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) =>({
  links: state.form.eventSubmission.values.links,
  ticketingUrlType: state.form.eventSubmission.values.ticketing_url_type,
  prices: state.form.eventSubmission.values.prices,
  capacity: state.form.eventSubmission.values.capacity,
  currency: state.form.eventSubmission.values.currency,
  venue:  state.form.eventSubmission.values.venue,
  online:  state.form.eventSubmission.values.online,
  currencies: state.currencies,
  geotixEnabled: state.config.get('geotix_enabled'),
  premiumEdit: state.config.get('premium_edit'),
  ssoGeotixUrl: state.config.get('sso_geotix_url'),
  geotixVanityUrl: state.config.get('geotix_vanity_url'),
  pricing_type: state.form.eventSubmission.values.pricing_type,
  pricing_url: state.form.eventSubmission.values.pricing_url,
  ticketsRequired: state.form.eventSubmission.values.tickets_required,
  formErrors: state.submissionForm.getIn(['steps', 'tickets', 'errors']),
  urlTypes: state.urlTypes,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TicketsPage);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/SubmissionSteps/TicketsPage.jsx